<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" :data="updateLog.beanList" height="100%" row-key="id">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="修改类型" align="center">
                    <template slot-scope="scope">
                        {{scope.row.op | opName}}
                    </template>
                </el-table-column>
                <el-table-column label="修改前金豆数量" align="center" prop="beforeChips">
                  <template slot-scope="scope">
                    {{scope.row.beforeChips/100}}
                  </template>
                </el-table-column>
                <el-table-column label="修改数量" align="center" prop="changeChip">
                  <template slot-scope="scope">
                    {{scope.row.changeChip/100}}
                  </template>
                </el-table-column>
                <el-table-column label="修改后金豆数量" align="center" prop="afterChips">
                  <template slot-scope="scope">
                    {{scope.row.afterChips/100}}
                  </template>
                </el-table-column>
                <el-table-column label="操作账号" align="center" prop="adminName"/>
                <el-table-column label="操作时间" width="150" align="center" prop="opTime"/>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="updateLog.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage:1
            }
        },
        computed: {
            ...mapState('market', ['updateLog'])
        },
        filters: {
              opName(op) {
                switch (op) {
                    case 2:
                        op = '增加';
                        break;
                    case 5:
                        op = '减少';
                        break;
                    case 6:
                        op = '修改为';
                        break;
                    default:
                        break;
                }
                return op;
            }
        },
        methods: {
            ...mapActions('market', ['getUpdateLogList']),
            getList(page = 1) {
              this.loading = true;
              this.currentPage = page;
              this.getUpdateLogList(page).then(() => {
                this.loading = false;
              })
            }
        }
    }
</script>
